import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	loading: true,
	error: false,
	data: [],
	columns: [],
	deleteItem: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		page: 0,
		total_results: 0,
		startIndex: 0,
		sorted: undefined,
		filters: {
			query: '',
			filterUrlQuery: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_PANEL_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH MENU ***************
			case types.FETCH_MENU_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_MENU_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				draft.options.startIndex = action.payload.startIndex;
				draft.options.page = action.payload.page;
				return;

			case types.FETCH_MENU_ERROR:
				draft.error = action.payload;
				return;

			// *************** DELETE MENU_ITEM ***************
			case types.DELETE_MENU_ITEM_LOADING:
				draft.deleteItem.success = false;
				draft.deleteItem.error = false;
				return;

			case types.DELETE_MENU_ITEM_SUCCESS:
				draft.deleteItem.success = action.payload;
				draft.deleteItem.error = false;
				return;

			case types.DELETE_MENU_ITEM_ERROR:
				draft.deleteItem.error = action.payload;
				return;

			// *************** SAVE SORTING OPTIONS ***************
			case types.SAVE_MENU_TABLE_SORTING:
				draft.options.sorted = action.payload;
				break;

			// *************** SET SEARCH QUERY ***************
			case types.SET_MENU_SEARCH_QUERY:
				draft.options.filters.query = action.payload;
				return;

			// --------------- FILTERS ---------------
			// *************** SET FILTER URL QUERY ***************
			case types.SET_FILTER_URL_QUERY:
				draft.options.filters.filterUrlQuery = action.payload;
				break;

			// *************** CLEAR FILTERS ***************
			case types.CLEAR_FILTERS:
				draft.options.filters.filterUrlQuery = '';
				break;

			default:
				return state;
		}
	});
